/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcSweepsClearingV1SweepOrderEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_SWEEPS_CLEARING_V1_SWEEP_ORDER_EVENT_ENTITY_NAME = 'ixc.sweeps.clearing.v1.SweepOrderEvent';
export const ixcSweepsClearingV1SweepOrderEventEntity = new schema.Entity<IxcSweepsClearingV1SweepOrderEvent>(IXC_SWEEPS_CLEARING_V1_SWEEP_ORDER_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcSweepsClearingV1SweepOrderEvent) => `${entity.metadata?.eventId}` });

